import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from '../contexts/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from "../utils/icons";
import FinancingInfo from "../components/FinancingInfo";
import { getLogoByLanguage } from "../utils/getLogoByLanguage";

const Install = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isDownloadReady, setIsDownloadReady] = useState(false);
  const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
  const { language, translations } = useLanguage();
  const mainLogoUrl = getLogoByLanguage(language);

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setIsDownloadReady(true);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', () => {});
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      try {
        await deferredPrompt.prompt();
        const choiceResult = await deferredPrompt.userChoice;
        if (choiceResult.outcome === 'accepted') {
          setIsInstalled(true);
          setIsDownloadReady(true);
        }
        setDeferredPrompt(null);
      } catch (error) {
        console.error('Failed to prompt for install:', error);
      }
    }
  };

  return (
    <div className="install-container">
      <div className="install-box">
        <div className="card">
          <img src={mainLogoUrl} className='card-header-logo' alt='Install Page Logo'></img>
          <p><strong>{translations.installpage.welcome}</strong></p>
          <p>{translations.installpage.description}</p>
          <p className="install-info-text"><FontAwesomeIcon icon={icons.download} className="listIcon"/> {translations.installpage.installinfo1}</p>
          <p className="install-info-text"><FontAwesomeIcon icon={icons.exclamationCircle} className="listIcon"/> {translations.installpage.installinfo2}</p>
          {!isInstalled && !isIos && deferredPrompt && (
            <button className="big-button install" onClick={handleInstallClick}>
              <FontAwesomeIcon icon={icons.download} className="listIcon"/>
              {translations.installpage.install}
            </button>
          )}
          {!isInstalled && !isIos && !deferredPrompt && (
            <p className="install-info-text"><FontAwesomeIcon icon={icons.questionCircle} className="listIcon"/> {translations.installpage.installinfo3}</p>
          )}
          {isDownloadReady && (
            <div className="install-ready">
              <div className="install-checkmark-wrapper">
                <svg className="install-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                  <circle className="install-checkmark-circle" cx="26" cy="26" r="25" fill="#4CAF50" />
                  <path className="install-checkmark-check" fill="none" d="M14 27l7 7 16-16" />
                </svg>
              </div>
              <p className="install-ready-text">{translations.installpage.installready}</p>
              <p className="install-ready-subtext">{translations.installpage.findit}</p>
            </div>
          )}
          {isIos && (
            <div className="card ios-info">
              <h3>{translations.installpage.installios}</h3>
              <ul>
                <li>
                  <strong>{translations.installpage.iosinfo1}</strong>
                  <FontAwesomeIcon icon={icons.compass} className="listIcon"/>
                </li>
                <li>
                  <strong>{translations.installpage.iosinfo2}</strong>
                  <FontAwesomeIcon icon={icons.arrowUpFromBracket} className="listIcon"/><br/>
                </li>
                <li>
                  <strong>{translations.installpage.iosinfo3}</strong>
                  <FontAwesomeIcon icon={icons.plusSquare} className="listIcon"/>"
                </li>
                <li>
                  <strong>{translations.installpage.iosinfo4}</strong>
                  <FontAwesomeIcon icon={icons.check} className="listIcon"/>
                </li>
              </ul>
            </div>
          )}
          <span className="pswreg"><Link to="/login">{translations.installpage.skipInstall}</Link></span>
        </div>
        <FinancingInfo />
      </div>
    </div>
  );
}

export default Install;